import React, { Component } from "react";
import { Link } from "react-router-dom";
import Alert from "sweetalert-react";
import * as Http from "../../../http";
import * as Business from "../../../utils/business";
import Loading from "../../../components/Loading";
import { MenuItem, DropdownButton } from "react-bootstrap";

const dicSearchOptions = {
  report_date: "Report Date",
  file_name: "Report Name",
  approval_by: "Approver",
};

class FileManagement extends Component {
  state = {
    searchOption: "report_date",
    searchValue: "",
    items: [],
    loading: true,
  };

  reportWillDeleteObj = null;

  componentDidMount() {
    this.getUploadManagement();
  }

  getUploadManagement = () => {
    Http.getUploadManagement(Business.COMPONENT.LIQUIDITY_V2, null)
      .then((data) => {
        if (data && data.Success) {
          let listData = [];
          for (let index = 0; index < data.Data.length; index++) {
            const element = data.Data[index];
            if (element && element.file_name.startsWith("LIQUIDITY_V2")) {
              element.timestamp = new Date(element.upload_time).getTime();
              listData.push(element);
            }
          }
          listData = listData.sort((a, b) => b.timestamp - a.timestamp);
          this.setState({ items: listData, loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  search = () => {
    const objSearch = {
      report_date:
        this.state.searchOption === "report_date"
          ? this.state.searchValue
          : null,
      file_name:
        this.state.searchOption === "file_name" ? this.state.searchValue : null,
      approval_by:
        this.state.searchOption === "approval_by"
          ? this.state.searchValue
          : null,
    };

    Http.getUploadManagement(Business.COMPONENT.LIQUIDITY_V2, objSearch)
      .then((data) => {
        if (data && data.Success) {
          let listData = [];
          for (let index = 0; index < data.Data.length; index++) {
            const element = data.Data[index];
            if (element && element.file_name.startsWith("LIQUIDITY_V2")) {
              element.timestamp = new Date(element.upload_time).getTime();
              listData.push(element);
            }
          }
          listData = listData.sort((a, b) => b.timestamp - a.timestamp);
          this.setState({ items: listData, loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => this.setState({ loading: false }));
  };

  deleteListItems = () => {
    Http.deleteListReport(
      Business.COMPONENT.LIQUIDITY_V2,
      this.reportWillDeleteObj,
    ).then((res) => {
      if (res.Success) {
        this.getUploadManagement();
      }
    });
    this.reportWillDeleteObj = null;
  };

  onDelete = (reportName, reportDate) => {
    this.reportWillDeleteObj = {
      file_name: reportName,
      report_date: reportDate,
    };
    this.setState({ showDeleteAlert: true });
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      <div className="card">
        <div className="header">
          <h4 className="title">File Management</h4>
        </div>
        <div className="content table-full-width">
          <div className="ey-search-bar">
            <DropdownButton
              title={dicSearchOptions[this.state.searchOption]}
              bsSize="small"
              id="liquidity-v2-fm-dropdown"
            >
              <MenuItem
                onSelect={() => this.setState({ searchOption: "report_date" })}
                eventKey="report_date"
              >
                Report Date
              </MenuItem>
              <MenuItem divider />
              <MenuItem
                onSelect={() => this.setState({ searchOption: "file_name" })}
                eventKey="file_name"
              >
                Report Name
              </MenuItem>
              <MenuItem divider />
              <MenuItem
                onSelect={() => this.setState({ searchOption: "approval_by" })}
                eventKey="approval_by"
              >
                Approver
              </MenuItem>
              <MenuItem divider />
            </DropdownButton>
            <input
              type="text"
              className="form-control ey-search-input"
              onChange={(e) => this.setState({ searchValue: e.target.value })}
            />
            <button
              type="button"
              className="btn btn-primary ey-search-btn"
              onClick={this.search}
            >
              Search
            </button>
          </div>
          <div style={{ height: 15 }} />
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>Report Date</th>
                <th>Report Name</th>
                <th>Action</th>
                <th>Uploader</th>
                <th>Upload Time</th>
                <th>Approver</th>
                <th>Approval Time</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.state.items.map((item) => (
                <tr key={item.file_name + item.report_date}>
                  <td>{Business.convertToDate(item.report_date)}</td>
                  <td>
                    <Link
                      to={{
                        pathname: `/liquidity-v2/file-info/${Business.convertToDate(item.report_date)}/${item.file_name}`,
                        state: item,
                      }}
                      style={{ color: "blue" }}
                    >
                      {String(item.file_name).substring("LIQUIDITY_V2_".length)}
                    </Link>
                  </td>
                  <td>{Business.convertUploadType(item.upload_type)}</td>
                  <td>{item.upload_by}</td>
                  <td>{Business.convertToFullDate(item.upload_time)}</td>
                  <td>{item.approval_by}</td>
                  <td>{Business.convertToFullDate(item.approval_time)}</td>
                  <td>{Business.convertFileStatus(item.status)}</td>
                  <td className="text-right">
                    {Business.isHasRole([
                      Business.ROLE_DEFINE_MAP.ICAAP_DELETE_REPORT,
                    ]) ? (
                      <a
                        rel="tooltip"
                        aria-disabled="true"
                        className="btn btn-info btn-simple btn-xs"
                        onClick={() =>
                          this.onDelete(item.file_name, item.report_date)
                        }
                      >
                        <i
                          style={{ fontSize: 23, color: "red" }}
                          className="pe-7s-trash"
                        ></i>
                      </a>
                    ) : (
                      <div></div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Alert
          title="Are you sure?"
          show={this.state.showDeleteAlert}
          text="You will not be able to recover this report!"
          showCancelButton
          onConfirm={() => {
            this.setState({ showDeleteAlert: false });
            this.deleteListItems();
          }}
          onCancel={() => {
            this.setState({ showDeleteAlert: false });
            this.reportWillDeleteObj = null;
          }}
        />
      </div>
    );
  }
}

export default FileManagement;



// WEBPACK FOOTER //
// src/pages/LiquidityV2/FileManagement/FileManagement.js